export default __webpack_public_path__ + "static/media/bookTwo.f6bd85a3.png";